import React from 'react';
import {
    Box,
    Button,
    Stack,
    Typography
} from '@mui/material'
import { useRouteError } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as Logo } from '../logo.svg';

export default function Error() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const error = useRouteError();

    console.log(error);

    const handleBack = () => {
        navigate('/')
    }
    
    return (
        <Box 
            sx={{
            minHeight: {
                sm: "100vh"
            },
            display: "flex",
            flexDirection: "column",
            justifyContent: {
                xs: "flex-start", // top on mobile
                sm: "center",     // center on larger screens
            },
            alignItems: "center",
            px: 2, // small side padding for mobile
            pt: {
                xs: 2, // top padding on mobile
                sm: 0, // no extra padding on desktop
            },
            pb: {
                xs: 2, // top padding on mobile
                sm: 0, // no extra padding on desktop
            }
        }}>
            <Box
                sx={{
                p: 2,
                bgcolor: "white",
                borderRadius: 2,
                boxShadow: 3,
                width: {
                    xs: "100%", // full width on mobile
                    sm: "700px", // fixed width on larger screens
                },
                maxWidth: "600px",
                height: "auto",
                overflow: "hidden",
                }}
            >
                <Stack spacing={1}
                       alignItems="center" // Center stack items horizontally
                       textAlign="center"   // Center text within each item
                >
                    {/* Centered logo */}
                    <Logo width="256px" height="auto" />
                    
                    <Typography variant='subtitle1' fontSize={'18px'}>
                        {t('errorTitle')}
                    </Typography>
            
                    <Typography variant='subtitle2'>
                        {t('errorMessage')}
                    </Typography>

                    <Button variant="contained" onClick={handleBack}>
                        {t('errorGoBackButton')}
                    </Button>
                </Stack>                                
            </Box>
        </Box>
    )
}